import { V3Record } from 'data/helpers/V3Record.js'

export const TmsValue = V3Record('tmsValue', {
  language: null,
  value: null,
  tmsSetId: null,
  createdAt: null,
  updatedAt: null
})
